var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTablePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resouce / Illust / Bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 16H46V46H4V16Z",
    fill: "#E7EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 11.5V16H17V13.7048H33V16H36V11.5C36 11.2239 35.7761 11 35.5 11H14.5C14.2239 11 14 11.2239 14 11.5Z",
    fill: "#CFD6D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5 21H53.5L46 46H4L11.5 21Z",
    fill: "#F7F9FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTablePlaceholder);
export default __webpack_public_path__ + "static/media/icon-table-placeholder.e5a3aa72df64ed5fd7890e471e3d7d80.svg";
export { ForwardRef as ReactComponent };